// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__ghut4"};